import { AddBoxTwoTone } from '@mui/icons-material'
import React from 'react'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box'

import AddStiki from './AddStiki'
import { selectPageIsMine } from '../pages/pagesSlice'

const classes = {
  root: {
    backgroundColor: 'rgb(255, 0, 0)',
    position: 'fixed',
    height: '8px',
    left: '3%',
    right: '3%',
    bottom: '0px',
    height: '48px',
    overflow: 'hidden',
    backgroundColor: '#222',
    borderRadius: '20px 20px 0 0',
    '& .bottomPaneContents': {
      top: 0,
      fontSize: '110%',
      height: '36px',
      margin: '0 auto',
      maxWidth: '600px',
      marginTop: '12px',
      textAlign: 'center',
    },
  },

  pagesPaneShowing: {
    left: '240px',
    borderRadius: '0 20px 0 0',
  },
}

export default function BottomPane({ pageId, pagesPaneIsVisible }) {
  const isMine = useSelector(selectPageIsMine(pageId))

  // This whole bar exists to hold the box for making a stiki. On a page shared
  // with me there is nothing to put in it, so the bar goes too rather than
  // sitting there empty.
  if (!isMine) {
    return null
  }

  return (
    <Box
      sx={{
        ...classes.root,
        ...(pagesPaneIsVisible ? classes.pagesPaneShowing : {}),
      }}
    >
      <div className='bottomPaneContents'>
        <AddStiki pageId={pageId} />
      </div>
    </Box>
  )
}
